<!--  -->
<template>
<div>
   <div class="container logo-box">
        <a href="/" class="logo" title="考试系统"><img :src="`/static/images/logo.png?t=${Math.random()}`" alt="logo"></a>
         <el-button  @click="$router.push('/')" class="personcenter" round >首页</el-button>
           </div>
    <div class="w3layoutscontaineragileits">
      <div class="img-edge-cover"><img src="/static/images/bg_ta.png"/></div>
        <h2 class="title">请&nbsp;登&nbsp;录</h2>
        <div class="lightline"></div>
        <div>
            <input type="text" class="inptCard" v-model="loginUser.identificationcard" placeholder="请输入身份证号码" required>
            <input type="password" class="inptPass"  v-model="loginUser.password" placeholder="请输入密码" required>
            <ul class="agileinfotickwthree">
                <li>
                    <input type="checkbox"  id="brand1" v-model="checked" >
                    <label for="brand1" style="margin-top: 16px;margin-left: 3px;"><span class="agiletext">记住我的登录信息</span></label>
                </li>
            </ul>
            <div class="aitssendbuttonw3ls">
                <input type="submit" @click="submitForm()" value="登 录">
                <div class="clear"></div>
            </div>
            
        </div>
    </div>
    <footer-nav/>
</div>

</template>
<script>
import jwt_decode from "jwt-decode";
import global from "../components/PublicComs/Common.vue";
import { Message } from "element-ui";
import FooterNav from '../components/HomeComs/FooterNav.vue';
const rate= window.innerWidth/1240;
export default {
      metaInfo: {
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
      ]
    },
  data() {
    return {
      loginUser: {
        password: "",
        identificationcard: "",
        yzcode: "",
        yzmsrc: "",
      },
      global,
      webConfig: {},
      checked: false,
    };
  },

  components: {FooterNav},

  computed: {},

  mounted() {
    this.$axios.get("/api/webConfigs").then((res) => {
      if (res.data && res.data.data.length > 0) {
        this.webConfig = res.data.data[0];
      }
    });
    this.getImgVerify();
    this.getCookie();
    window.addEventListener("keydown", this.keyDown);
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute(
        "style",
        'font-family:Verdana;background: url("/static/images/bg_denglu.png");background-repeat: no-repeat;background-position: center;background-size: cover;-webkit-background-size: cover;-moz-background-size: cover;-o-background-size: cover;'
      );
  },
  beforeDestroy() {
    document.body.removeAttribute("style");
    window.removeEventListener("keydown", this.keyDown, false);
     document
      .querySelector("body")
      .setAttribute(
        "style",
        'font-family:Verdana;background: url("/static/images/bg.png");background-repeat: no-repeat;background-attachment: fixed;background-position: center;background-size: cover;-webkit-background-size: cover;-moz-background-size: cover;-o-background-size: cover;'
      );
  },
  created() {},
  methods: {
    submitForm() {
      if (!this.loginUser.password) {
        Message.error("密码不能为空！");
        return;
      } else if (!this.loginUser.identificationcard) {
        Message.error("身份证号码不能为空！");
        return;
      }
      this.$axios.post("/api/auth/login", this.loginUser).then((res) => {
        // 登录成功
        const self = this;
        //判断复选框是否被勾选 勾选则调用配置cookie方法
        if (self.checked == true) {
          console.log("checked == true");
          //传入账号名，密码，和保存天数3个参数
          self.setCookie(
            this.loginUser.password,
            this.loginUser.identificationcard,
            30
          );
        } else {
          console.log("清空Cookie");
          //清空Cookie
          self.clearCookie();
          self.setCookie(this.loginUser.password, "", 30);
        }
        const { token } = res.data;
        localStorage.setItem("eleTokenWrd001", token);

        // 解析token
        const decode = jwt_decode(token);
        // 存储数据
        this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
        this.$store.dispatch("setUser", decode);
        //获取购买的课程
          let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.$root.hasCourse =arrhasCourse;
        this.$root.ischeckface = res.data.data.ischeckface;
        this.$root.onlymycourse = res.data.data.onlymycourse;
        this.$root.buytype = res.data.data.buytype;
        if( res.data.data.onlymycourse)
            localStorage.setItem("onlymycourseWrd", "1");
        else
          localStorage.setItem("onlymycourseWrd", "0");
        localStorage.setItem("hasCourseWrd", arrhasCourse.join(","));
        // 页面跳转
        this.$router.push("/");
      });
    },
    getImgVerify() {
      this.loginUser.yzmsrc =
        `${this.global.remoteIp}/api/auth/imgverify` + "?" + Math.random();
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.submitForm();
      }
    },
    //设置cookie
    setCookie(c_name, c_id, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "stuName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      if (c_id) {
        window.document.cookie =
          "stuId" + "=" + c_id + ";path=/;expires=" + exdate.toGMTString();
      }
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "stuName") {
            this.loginUser.password = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "stuId") {
            this.loginUser.identificationcard = arr2[1];
            this.checked = true;
          }
        }
      }
    },
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
  },
};
</script>
<style lang="scss" scoped>
.w3layoutscontaineragileits{
  width: 647px;
  height: 504px;
  
  border: 1px solid #4182CA;
  box-shadow: 0px 2px 10px 1px rgba(66, 130, 202, 0.2), 0px 1px 2px 0px #FFFFFF;
  
  background: linear-gradient(0deg, #BEDAF8, #EDF6FF, #FFFFFF);
  background-image:url('/static/images/bg_ta.png') no-repeat bottom left;
  margin:45px auto 76px;
}
.lightline{
  width: 645px;
height: 1px;
background: #ffffff;
box-shadow: 0px 6px 7px 0px rgba(66, 130, 202, 0.5);
}
.title{
  text-align: center;
        margin-top: 41px;
    margin-bottom:27px ;
    font-size: 32px;
font-weight: bold;
color: #4282CA;
font-family: PingFang-SC-Medium;
}
.inptCard{
  width: 532px;
  height: 71px;
  background: #FFFFFF;
  border: 1px solid #4282CA;
  opacity: 0.75;
  border-radius: 3px;
  margin: 48px auto;
    display: block;
  background-image: url("/static/images/icon_shouji.png");
  background-repeat: no-repeat;
      background-position: 21px 22px;
    padding: 0 65px;
}
.inptPass{
  margin: 48px auto 0;
    display: block;
    width: 532px;
height: 71px;
background: #FFFFFF;
border: 1px solid #4282CA;
opacity: 0.75;
border-radius: 3px;
  background-image: url("/static/images/icon_yanzhegnma.png");
  background-repeat: no-repeat;
      background-position: 21px 22px;
    padding: 0 65px;
}
.agiletext{
  width: 111px;
  height: 14px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #636A76;
  line-height: 43px;
}
input[type=checkbox]{
  width: 18px;
    height: 18px;
    border: 1px solid #4282CA;
    margin-top: 29px;
    float: left;
}
.agileinfotickwthree{
  position: relative;
  margin-left: 56px;
}
.aitssendbuttonw3ls{
  text-align:center;
}
.aitssendbuttonw3ls input{
  position: relative;
  background-image: url('/static/images/btn_tijaxiugai.png');
  background-repeat: no-repeat;
  margin: auto;
  text-align:center;
  width: 217px;
  height: 68px;
  border:0;
font-size: 24px;
font-family: PingFang-SC-Medium;
font-weight: 500;
color: #FFFFFF;
line-height: 30px;
}
.img-edge-cover {
  position:absolute;
  width: 253px;
    top:311px;
}
.img-edge-cover img{
    width: 253px;
    display: block;
    margin-bottom: 20px;
        opacity: 0.7;
}
</style>
